import RefreshIcon from '@mui/icons-material/Refresh';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { collectionApis } from '../../../apis/collectionApis';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';
import ActionButton from '../../elements/action-button/ActionButton';

const ReloadButton = ({ selectedCollection }) => {
  const { projectId, instanceId } = useParams();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const handleReload = async () => {
    try {
      await collectionApis.reloadCollection(
        projectId,
        instanceId,
        selectedCollection
      );

      showToast(
        TOAST_TYPE.SUCCESS,
        t('reloadSuccess', { ns: 'notifications' })
      );
    } catch (error) {
      showToast(TOAST_TYPE.ERROR, t('reloadError', { ns: 'notifications' }));
    }
  };

  return (
    <ActionButton clickAction={handleReload} startIcon={<RefreshIcon />}>
      {t('reload', { ns: 'buttons' })}
    </ActionButton>
  );
};

ReloadButton.propTypes = {
  selectedCollection: PropTypes.string.isRequired,
};

export default ReloadButton;
